import React from "react";
import {observer} from "mobx-react";
import {
    GamesOpenSessionRecordHeaderBox
} from "./boxes/container/games-open-session-record-header.box";
import {IGameOpenSessionViewModel} from "../../../../services/games-open-sessions/games-open-session.service.interface";
import {GamesOpenSessionRecordGameNameBox} from "./boxes/game-name/games-open-session-record-game-name.box";
import {CyClass} from "../../../../../common/cy-classes";
import {GameInfo} from "../../../../services/games/game-info";

export const GamesOpenSessionRecordHeaderComponent: React.FC<{openSession: IGameOpenSessionViewModel; gameInfo: GameInfo}> = observer((props)=> {

    return (
        <GamesOpenSessionRecordHeaderBox className={CyClass('cy-open-session-record-header')}>
            <GamesOpenSessionRecordGameNameBox className={CyClass('cy-open-session-record-game-name')}>
                {props.gameInfo.title}
            </GamesOpenSessionRecordGameNameBox>
            <div className={CyClass('cy-open-session-record-session-id')}>
                {props.openSession.sessionId}
            </div>
        </GamesOpenSessionRecordHeaderBox>
    )
})